var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep5Upcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "#9FB693"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7499 35.2401C63.7485 36.6823 63.3727 38.0993 62.6592 39.3526C61.9458 40.606 60.9192 41.6526 59.6799 42.3901H13.7299C12.1488 40.8146 11.1885 38.7221 11.0251 36.4961C10.8616 34.27 11.5059 32.0596 12.8399 30.2701C11.3597 28.1391 10.6436 25.5702 10.808 22.9808C10.9724 20.3914 12.0076 17.9337 13.7455 16.007C15.4833 14.0803 17.8216 12.798 20.3804 12.3683C22.9392 11.9386 25.5681 12.3868 27.8399 13.6401C28.7121 12.1979 29.9605 11.0204 31.4513 10.234C32.9421 9.44766 34.6188 9.08216 36.3016 9.17673C37.9844 9.27131 39.6097 9.82239 41.0029 10.7708C42.3962 11.7192 43.5049 13.0292 44.2099 14.5601C46.0391 13.419 48.1919 12.9089 50.3386 13.1078C52.4854 13.3068 54.5077 14.2039 56.096 15.6617C57.6843 17.1196 58.7511 19.0578 59.1328 21.1797C59.5146 23.3015 59.1904 25.49 58.2099 27.4101C59.8302 27.9814 61.2332 29.0414 62.2255 30.4438C63.2178 31.8463 63.7504 33.5221 63.7499 35.2401Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7555 21H26.2445C24.4526 21 23 22.3211 23 23.9508V57.0492C23 58.6789 24.4526 60 26.2445 60H45.7555C47.5474 60 49 58.6789 49 57.0492V23.9508C49 22.3211 47.5474 21 45.7555 21Z",
    fill: "#302322"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57C37.1046 57 38 56.1046 38 55C38 53.8954 37.1046 53 36 53C34.8954 53 34 53.8954 34 55C34 56.1046 34.8954 57 36 57Z",
    fill: "#534645"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43C37.1046 43 38 42.1046 38 41C38 39.8954 37.1046 39 36 39C34.8954 39 34 39.8954 34 41C34 42.1046 34.8954 43 36 43Z",
    fill: "#EEC98A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 35.5C34.4672 35.5 33.0737 36.1002 32.0325 37.0881C31.4315 37.6583 30.4821 37.6334 29.9119 37.0325C29.3417 36.4315 29.3666 35.4821 29.9675 34.9119C31.5407 33.4192 33.6644 32.5 36 32.5C38.3356 32.5 40.4593 33.4192 42.0325 34.9119C42.6334 35.4821 42.6583 36.4315 42.0881 37.0325C41.5179 37.6334 40.5685 37.6583 39.9675 37.0881C38.9263 36.1002 37.5328 35.5 36 35.5Z",
    fill: "#EEC98A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 29.5C33.2773 29.5 30.8171 30.5016 28.997 32.1207C28.378 32.6713 27.4299 32.6159 26.8793 31.997C26.3287 31.378 26.3841 30.4299 27.003 29.8793C29.3658 27.7774 32.5333 26.5 36 26.5C39.4667 26.5 42.6342 27.7774 44.997 29.8793C45.6159 30.4299 45.6714 31.378 45.1208 31.997C44.5701 32.6159 43.622 32.6713 43.003 32.1207C41.1829 30.5016 38.7227 29.5 36 29.5Z",
    fill: "#EEC98A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5Upcoming);
export default __webpack_public_path__ + "static/media/step5-upcoming.08fa1b8b6a1b5c8c952dadb7539f594a.svg";
export { ForwardRef as ReactComponent };